/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VeranstaltungBerechtigung { 
    veranstaltung_id: string;
    benutzer_ist_veranstaltungsleiter?: boolean;
    benutzer_id: string;
    benutzer_ist_beobachter?: boolean;
    benutzer_ist_funktionsbereich_admin?: boolean;
    benutzer_kann_kopfdaten?: boolean;
    benutzer_kann_dienstplan?: boolean;
    benutzer_kann_info_kategorien?: boolean;
    benutzer_kann_aktionen?: boolean;
    benutzer_kann_dokumente?: boolean;
    benutzer_kann_beenden?: boolean;
    benutzer_kann_loeschen?: boolean;
    benutzer_kann_reaktivieren?: boolean;
    benutzer_kann_veroeffentlichen?: boolean;
    benutzer_kann_mitteilungen_senden?: boolean;
    benutzer_kann_funkprotokoll?: boolean;
    benutzer_kann_dienstplan_bearbeiten?: boolean;
    benutzer_kann_aufgaben_berechtigungen_bearbeiten?: boolean;
    benutzer_kann_kopieren?: boolean;
    benutzer_ist_veranstaltungstyp_admin?: boolean;
    typ_ist_fb_admin_zugriff?: boolean;
    benutzer_ist_admin?: boolean;
    ist_aufgabe_neutral_text_optional?: boolean;
    ist_aufgabe_nichtok_text_optional?: boolean;
}

